import Heading from "@commons/Typography/Heading";
import Text from "@commons/Typography/Text";

type CardProps = {
  title: string;
  value: number;
  variant: "cyan" | "blue" | "red" | "gray";
};

const CARD_VARIANTS = {
  cyan: "bg-cyan-500",
  blue: "bg-blue-500",
  red: "bg-red-700",
  gray: "bg-stone-600",
} as const;

function Card({ title, value, variant = "cyan" }: CardProps) {
  return (
    <div
      className={`${CARD_VARIANTS[variant]} text-white px-6 py-3 rounded-3xl shadow-md w-40 flex flex-col justify-between h-22 sm:h-26 xl:h-30`}
    >
      <Text customVariant="white" className="font-bold font-roboto">
        {title}
      </Text>

      <Heading size="lg" className="font-bold font-roboto text-end">
        {value}
      </Heading>
    </div>
  );
}

export default Card;
